import { FunctionComponent, type JSX, Suspense, lazy } from "react";

import {
  SelectControlAppearance,
  SelectControlProps,
} from "./SelectControlProps";

export const SelectControls: Record<
  `${SelectControlAppearance}`,
  FunctionComponent<SelectControlProps>
> = {
  Select: lazy(() => import("./SelectControl")),
  Autocomplete: lazy(() => import("./SelectControlAutocomplete")),
};

/**
 * Lazy loads select control
 * @param props
 * @returns
 */
export function Select(props: SelectControlProps): JSX.Element {
  const { appearance = SelectControlAppearance.Select } = props;
  const Control = SelectControls[appearance] ?? SelectControls.Select;
  return (
    <Suspense>
      <Control {...props} />
    </Suspense>
  );
}
